import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { FC } from 'react';
import TitleText from '../../components/formlib/TitleText';
import MediumTypography from '../../components/formlib/MediumTypography';
import { ReactComponent as CloseIcon } from '../../assets/images/x.svg';
import TimeOffBalancesCard, {
  TimeOutLogCardData,
} from '../../pages/profile/TimeOffBalancesCard';

export interface HolidayListProps {
  open: boolean;
  onClose: () => void;
  tbbTimeOffBalances: TimeOutLogCardData[];
}

const TimeOffBalanceDialogue: FC<HolidayListProps> = ({
  open,
  onClose,
  tbbTimeOffBalances,
}) => {
  
  return (
    <Dialog
      onClose={onClose}
      open={open}
      fullWidth
      maxWidth="sm"
      scroll="body"
      PaperProps={{
        sx: {
          width: '100%',
          maxWidth: '700px',
          borderRadius: '4px',
          margin: '20px',
        },
      }}
    >
      {tbbTimeOffBalances.length > 0 && (
        <DialogTitle
          sx={{
            padding: '16px 20px 10px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <TitleText
              labelid="timeOutLogsText"
              defaultlabel="Time off Balances"
            />

            <Box
              onClick={onClose}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '20px',
                height: '20px',
                flexShrink: 0,
                '& svg': {
                  display: 'block',
                },
              }}
            >
              <CloseIcon />
            </Box>
          </Box>
        </DialogTitle>
      )}

      {/* Cards */}
      <DialogContent
        sx={{
          padding: '4px 20px 20px !important',
        }}
      >
        {tbbTimeOffBalances.length === 0 ? (
          <Box sx={{ textAlign: 'center', padding: '32px 0' }}>
            <MediumTypography
              defaultlabel="There is no data to display"
              label="There is no data to display"
              fontweight={700}
            />
          </Box>
        ) : (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
              gridAutoRows: '1fr',
              gap: '6px',
              width: '100%',
            }}
          >
            {tbbTimeOffBalances.map((item, index) => (
              <TimeOffBalancesCard
                key={`${item.name}-${index}`}
                data={item}
              />
            ))}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default TimeOffBalanceDialogue;
